import { __decorate, __param } from 'tslib';
import { isPlatformServer, DOCUMENT, CommonModule } from '@angular/common';
import { Inject, ChangeDetectorRef, PLATFORM_ID, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { TuiDestroyService, TuiLetModule } from '@taiga-ui/cdk';
import { TuiSvgService } from '@taiga-ui/core/services';
import { innerHTML } from '@taiga-ui/core/utils/polyfills';
import { takeUntil } from 'rxjs/operators';

// @dynamic
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core/services';
import * as ɵngcc3 from '@taiga-ui/cdk';

function TuiSvgDefsHostComponent__svg_ng_container_1__svg_defs_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "defs", 4);
} if (rf & 2) {
    const def_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", def_r4, ɵngcc0.ɵɵsanitizeHtml);
} }
function TuiSvgDefsHostComponent__svg_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiSvgDefsHostComponent__svg_ng_container_1__svg_defs_1_Template, 1, 1, "defs", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
function TuiSvgDefsHostComponent__svg_ng_template_2__svg_defs_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "defs");
    ɵngcc0.ɵɵelement(1, "svg", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const def_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("outerHTML", def_r6, ɵngcc0.ɵɵsanitizeHtml);
} }
function TuiSvgDefsHostComponent__svg_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵtemplate(0, TuiSvgDefsHostComponent__svg_ng_template_2__svg_defs_0_Template, 2, 1, "defs", 5);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.items);
} }
let TuiSvgDefsHostComponent = class TuiSvgDefsHostComponent {
    constructor(documentRef, svgService, changeDetectorRef, destroy$, platformId) {
        this.svgService = svgService;
        this.changeDetectorRef = changeDetectorRef;
        this.destroy$ = destroy$;
        this.isBrowser = true;
        this.isBrowser = !isPlatformServer(platformId);
        innerHTML(documentRef);
    }
    // @bad TODO: Looks like it could be async piped but it was probably written like that for a reason
    ngOnInit() {
        this.svgService.items$.pipe(takeUntil(this.destroy$)).subscribe(defsMap => {
            this.items = defsMap.values();
            this.changeDetectorRef.detectChanges();
        });
    }
};
TuiSvgDefsHostComponent.ɵfac = function TuiSvgDefsHostComponent_Factory(t) { return new (t || TuiSvgDefsHostComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(TuiSvgService), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TuiDestroyService), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
TuiSvgDefsHostComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiSvgDefsHostComponent, selectors: [["tui-svg-defs-host"]], features: [ɵngcc0.ɵɵProvidersFeature([TuiDestroyService])], decls: 4, vars: 2, consts: [["version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink"], [4, "ngIf", "ngIfElse"], ["server", ""], [3, "innerHTML", 4, "ngFor", "ngForOf"], [3, "innerHTML"], [4, "ngFor", "ngForOf"], [3, "outerHTML"]], template: function TuiSvgDefsHostComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵtemplate(1, TuiSvgDefsHostComponent__svg_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, TuiSvgDefsHostComponent__svg_ng_template_2_Template, 1, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isBrowser)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf], styles: ["[_nghost-%COMP%]{display:none}"], changeDetection: 0 });
TuiSvgDefsHostComponent.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: TuiSvgService, decorators: [{ type: Inject, args: [TuiSvgService,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: TuiDestroyService, decorators: [{ type: Inject, args: [TuiDestroyService,] }] },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
TuiSvgDefsHostComponent = __decorate([ __param(0, Inject(DOCUMENT)),
    __param(1, Inject(TuiSvgService)),
    __param(2, Inject(ChangeDetectorRef)),
    __param(3, Inject(TuiDestroyService)),
    __param(4, Inject(PLATFORM_ID))
], TuiSvgDefsHostComponent);

let TuiSvgDefsHostModule = class TuiSvgDefsHostModule {
};
TuiSvgDefsHostModule.ɵfac = function TuiSvgDefsHostModule_Factory(t) { return new (t || TuiSvgDefsHostModule)(); };
TuiSvgDefsHostModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiSvgDefsHostModule });
TuiSvgDefsHostModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TuiLetModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiSvgDefsHostComponent, [{
        type: Component,
        args: [{
                selector: 'tui-svg-defs-host',
                template: "<svg:svg\n    version=\"1.1\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n>\n    <ng-container *ngIf=\"isBrowser; else server\">\n        <defs\n            *ngFor=\"let def of items\"\n            [innerHTML]=\"def\"\n        ></defs>\n    </ng-container>\n    <ng-template #server>\n        <!--svg[outerHTML] - to support SSR, because there is no support of innerHTML for for defs element in domino-->\n        <defs *ngFor=\"let def of items\">\n            <svg [outerHTML]=\"def\"></svg>\n        </defs>\n    </ng-template>\n</svg:svg>\n",
                providers: [TuiDestroyService],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:none}"]
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc2.TuiSvgService, decorators: [{
                type: Inject,
                args: [TuiSvgService]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: ɵngcc3.TuiDestroyService, decorators: [{
                type: Inject,
                args: [TuiDestroyService]
            }] }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiSvgDefsHostModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiLetModule],
                declarations: [TuiSvgDefsHostComponent],
                exports: [TuiSvgDefsHostComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiSvgDefsHostModule, { declarations: function () { return [TuiSvgDefsHostComponent]; }, imports: function () { return [CommonModule, TuiLetModule]; }, exports: function () { return [TuiSvgDefsHostComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiSvgDefsHostComponent, TuiSvgDefsHostModule };

